/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {AdminResourceItemRoutePageComponent} from '../../common/controller/admin-resource-item-route-page.component';
import {AdminResourceContextRoutePageComponent} from '../../common/controller/admin-resource-context-route-page.component';
import {getRoutePageComponent} from '../../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../../routing/state-utils';
import {adminResourceItemRouteResolve} from '../../common/controller/admin-resource-routing';
import {MarketplaceProductCopyModalComponent} from './marketplace-product-copy-modal.component';
import {MarketplaceProductResource} from '../../../components/api/resources/resource/marketplace-product.resource';



export function marketplaceProductStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper('marketplace-products.marketplace-product', MarketplaceProductResource, 'app.adm', 'app/admin');
    
        const readOnlyResolve = /*@ngInject*/ function(): boolean  {
          const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

          const perms = LocalUserPermissions.getAllNetworkPermissions();
          return !perms.AX_PUBLISHER_ADMIN && !perms.MANAGE_SYSTEM;
        };
    
        $stateProvider.state(rh.listPath(), rh.list({
          views: {
            'content@app': { component: getRoutePageComponent('marketplace-product-route') }
          },
          resolve: {
            readOnly: readOnlyResolve
          }
        }));
    
        $stateProvider.state(rh.newItemPath(), rh.newItem());
    
        $stateProvider.state(rh.itemPath(), rh.modelCommsItem({
          resolve: Object.assign({}, adminResourceItemRouteResolve('marketplace-product-edit', 'edit'), {
            readOnly: readOnlyResolve,
            copyConfig: function() {
              return {
                modalComponent: MarketplaceProductCopyModalComponent,
                stateUrl: 'app.adm.marketplace-products.marketplace-product',
                lcase: 'marketplace product',
                ucase: 'Marketplace Product'
              };
            }
          }),
          views: {
            'content@app': { component: AdminResourceItemRoutePageComponent, bindings: { item: 'adminResourceItemKey', variant: 'adminResourceItemVariant' }  },
            'context@app': {component: AdminResourceContextRoutePageComponent}
          }
        }, 'MarketplaceProduct'));
  }, adnRouterHelper);
}
